


























































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeOutpatientWaiting } from "@/store/modules/OutpatientWaitingStore";
import OwtSvc from "@/services/OutpatientWaitingService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";

const THRESHOLD = 60;
const OBS_COUNT = 15;

interface ObservationRow {
  urutan: number;
  pasien_rm: string;
  pasien_nama: string;
  profesi_petugas: string;
  jam_t0: string;
  jam_t1: string;
  jenis_pasien: string;
  alasan_tidak_tercapai: string;
  uraian_tidak_tercapai: string;
  data_source: string;
  _rmLoading?: boolean;
}

interface RtlRow {
  masalah_gap: string;
  analisa_akar_masalah: string;
  rencana_tindak_lanjut: string;
}

@Component({
  components: { VCDateTimePicker }
})
export default class OutpatientWaitingForm extends Vue {
  @Prop({ default: null }) sessionData!: any;
  // Alias: list component passes event-data, accept both
  @Prop({ default: null }) eventData!: any;

  storeModule = storeOutpatientWaiting;
  session: any = null;
  saving = false;
  signing = false;
  importing = false;

  THRESHOLD = THRESHOLD;

  showSignPetugasDialog = false;
  showSignVerifikatorDialog = false;
  showSignKepalaUnitDialog = false;
  signPassword = "";

  warningSnackbar = false;
  warningMessage = "";

  metodeSamplingOptions = [
    { text: "Systematic First 15", value: "systematic_first15" },
    { text: "Random", value: "random" },
    { text: "Seluruh Kunjungan", value: "seluruh_kunjungan" },
  ];

  profesiOptions = [
    { text: "Dokter Umum", value: "dokter_umum" },
    { text: "Dokter Spesialis", value: "dokter_spesialis" },
    { text: "Dokter Subspesialis", value: "dokter_subspesialis" },
    { text: "Perawat Triage", value: "perawat_triage" },
    { text: "Bidan", value: "bidan" },
  ];

  jenisPasienOptions = [
    { text: "Umum", value: "umum" },
    { text: "BPJS", value: "bpjs" },
    { text: "Mandiri", value: "mandiri" },
    { text: "Online", value: "online" },
    { text: "Anjungan", value: "anjungan" },
  ];

  alasanTidakTercapaiOptions = [
    { text: "Dokter terlambat datang", value: "dokter_terlambat" },
    { text: "Pasien belum lengkap berkas", value: "berkas_belum_lengkap" },
    { text: "Antrian menumpuk", value: "antrian_menumpuk" },
    { text: "Sistem/IT gangguan", value: "sistem_gangguan" },
    { text: "Pasien belum hadir saat dipanggil", value: "pasien_belum_hadir" },
    { text: "Lainnya", value: "lainnya" },
  ];

  alasanUtamaOptions = [
    { text: "Dokter terlambat datang / belum hadir", value: "dokter_terlambat" },
    { text: "Pasien belum lengkap berkas administrasi", value: "berkas_belum_lengkap" },
    { text: "Antrian menumpuk melebihi kapasitas", value: "antrian_menumpuk" },
    { text: "Gangguan sistem IT / jaringan", value: "sistem_gangguan" },
    { text: "Pasien tidak hadir saat dipanggil", value: "pasien_belum_hadir" },
    { text: "Faktor lain (sebutkan di uraian)", value: "lainnya" },
  ];

  form: any = {
    tanggal_sampling: moment().format("YYYY-MM-DD"),
    poliklinik_kode: "",
    poliklinik_nama: "",
    petugas_nama: "",
    petugas_id: null,
    metode_sampling: "systematic_first15",
    alasan_tidak_tercapai_utama: [] as string[],
    uraian_lengkap: "",
    rencana_tindak_lanjut_umum: "",
  };

  observations: ObservationRow[] = [];

  rtlRows: RtlRow[] = [
    { masalah_gap: "", analisa_akar_masalah: "", rencana_tindak_lanjut: "" },
    { masalah_gap: "", analisa_akar_masalah: "", rencana_tindak_lanjut: "" },
    { masalah_gap: "", analisa_akar_masalah: "", rencana_tindak_lanjut: "" },
  ];

  // ==================== COMPUTED ====================
  get tanggalSamplingDate(): Date | null {
    return parseLocalDate(this.form.tanggal_sampling);
  }

  set tanggalSamplingDate(val: Date | null) {
    this.form.tanggal_sampling = val ? localISODate(val) : "";
  }

  get tglTerbit(): string {
    const d = this.tanggalSamplingDate;
    return d ? moment(d).format("D MMMM YYYY") : "-";
  }

  get isLocked(): boolean {
    return !!(
      this.session &&
      ["submitted", "verifikator_signed", "kepala_unit_signed", "published"].includes(this.session.status)
    );
  }

  get validObservations(): ObservationRow[] {
    return this.observations.filter(obs => obs.jam_t0 && obs.jam_t1);
  }

  get rowsTidakTercapai(): ObservationRow[] {
    return this.validObservations.filter(obs => {
      const wt = this.getWaktuTunggu(obs);
      return wt !== null && wt > THRESHOLD;
    });
  }

  get numerator(): number {
    return this.validObservations.filter(obs => {
      const wt = this.getWaktuTunggu(obs);
      return wt !== null && wt <= THRESHOLD;
    }).length;
  }

  get denominator(): number {
    return this.validObservations.length;
  }

  get capaianPct(): number {
    if (this.denominator === 0) return 0;
    return (this.numerator / this.denominator) * 100;
  }

  get statusCapaian(): string {
    return this.capaianPct >= 80 ? "tercapai" : "tidak_tercapai";
  }

  // ==================== METHODS ====================
  getWaktuTunggu(obs: ObservationRow): number | null {
    if (!obs.jam_t0 || !obs.jam_t1) return null;
    const base = this.form.tanggal_sampling || moment().format("YYYY-MM-DD");
    const t0 = moment(`${base} ${obs.jam_t0}`, "YYYY-MM-DD HH:mm");
    const t1 = moment(`${base} ${obs.jam_t1}`, "YYYY-MM-DD HH:mm");
    if (!t0.isValid() || !t1.isValid()) return null;
    const diff = t1.diff(t0, "minutes");
    return diff >= 0 ? diff : null;
  }

  initEmptyObservations() {
    this.observations = [];
    for (let i = 1; i <= OBS_COUNT; i++) {
      this.observations.push({
        urutan: i,
        pasien_rm: "",
        pasien_nama: "",
        profesi_petugas: "",
        jam_t0: "",
        jam_t1: "",
        jenis_pasien: "",
        alasan_tidak_tercapai: "",
        uraian_tidak_tercapai: "",
        data_source: "manual",
      });
    }
  }

  onPoliklinikChange() {
    const poli = this.storeModule.poliklinikList.find(
      (p: any) => p.kode === this.form.poliklinik_kode
    );
    this.form.poliklinik_nama = poli ? poli.nama : "";
  }

  populateFromSession() {
    if (!this.session) return;
    const s = this.session;

    const fields = [
      "tanggal_sampling", "poliklinik_kode", "poliklinik_nama",
      "petugas_nama", "petugas_id", "metode_sampling",
      "uraian_lengkap", "rencana_tindak_lanjut_umum",
    ];
    for (const f of fields) {
      if (s[f] !== undefined && s[f] !== null) {
        this.form[f] = s[f];
      }
    }

    if (s.tanggal_sampling) {
      this.form.tanggal_sampling = moment(s.tanggal_sampling).format("YYYY-MM-DD");
    }

    if (Array.isArray(s.alasan_tidak_tercapai_utama)) {
      this.form.alasan_tidak_tercapai_utama = [...s.alasan_tidak_tercapai_utama];
    }

    // Populate observations
    if (Array.isArray(s.observations) && s.observations.length > 0) {
      this.observations = [];
      for (let i = 0; i < OBS_COUNT; i++) {
        const src = s.observations[i] || {};
        const extractTime = (dt: string) => dt ? moment(dt).format("HH:mm") : "";
        this.observations.push({
          urutan: i + 1,
          pasien_rm: src.pasien_rm || "",
          pasien_nama: src.pasien_nama || "",
          profesi_petugas: src.profesi_petugas || "",
          jam_t0: src.jam_t0 || extractTime(src.jam_kontak_pendaftaran),
          jam_t1: src.jam_t1 || extractTime(src.jam_dilayani_dokter),
          jenis_pasien: src.jenis_pasien || "",
          alasan_tidak_tercapai: src.alasan_tidak_tercapai || "",
          uraian_tidak_tercapai: src.uraian_tidak_tercapai || "",
          data_source: src.data_source || "manual",
        });
      }
    }

    // Populate RTL rows
    if (Array.isArray(s.rtl_rows) && s.rtl_rows.length > 0) {
      this.rtlRows = [];
      for (let i = 0; i < 3; i++) {
        const src = s.rtl_rows[i] || {};
        this.rtlRows.push({
          masalah_gap: src.masalah_gap || "",
          analisa_akar_masalah: src.analisa_akar_masalah || "",
          rencana_tindak_lanjut: src.rencana_tindak_lanjut || "",
        });
      }
    }
  }

  autoFillPetugas() {
    const user = (appModule as any).user;
    if (user) {
      this.form.petugas_nama = user.nama || user.name || "";
      this.form.petugas_id = user.id || null;
    }
  }

  showWarning(message: string) {
    this.warningMessage = message;
    this.warningSnackbar = true;
  }

  validateBeforeSubmit(forSubmit: boolean): boolean {
    if (!this.form.tanggal_sampling) {
      this.showWarning("Tanggal Pelayanan wajib diisi");
      return false;
    }
    if (!this.form.poliklinik_kode) {
      this.showWarning("Unit / Poliklinik wajib diisi");
      return false;
    }
    if (!forSubmit) return true;

    // For submit: require at least 1 valid observation
    if (this.denominator === 0) {
      this.showWarning("Minimal 1 observasi harus memiliki data T0 dan T1");
      return false;
    }

    // Check alasan for tidak tercapai rows
    for (const row of this.rowsTidakTercapai) {
      if (!row.alasan_tidak_tercapai) {
        this.showWarning(`Alasan wajib diisi untuk pasien ${row.pasien_nama || row.urutan} (tidak tercapai)`);
        return false;
      }
    }

    // If capaian < 80%, require section F fields
    if (this.capaianPct < 80) {
      if (!this.form.alasan_tidak_tercapai_utama || this.form.alasan_tidak_tercapai_utama.length === 0) {
        this.showWarning("Alasan utama tidak tercapai wajib dipilih (Section F)");
        return false;
      }
    }

    return true;
  }

  buildPayload() {
    const trim = (v: any) => (v === null || v === undefined ? null : String(v).trim() || null);
    return {
      tanggal_sampling: this.form.tanggal_sampling,
      poliklinik_kode: trim(this.form.poliklinik_kode),
      poliklinik_nama: trim(this.form.poliklinik_nama),
      petugas_nama: trim(this.form.petugas_nama),
      petugas_id: this.form.petugas_id ? Number(this.form.petugas_id) : null,
      metode_sampling: this.form.metode_sampling,
      observations: this.observations
        .filter(obs => obs.pasien_rm && obs.pasien_rm.trim() !== "")
        .map(obs => {
          const tgl = this.form.tanggal_sampling || moment().format("YYYY-MM-DD");
          return {
            urutan: obs.urutan,
            pasien_rm: obs.pasien_rm || null,
            pasien_nama: obs.pasien_nama || null,
            tgl_observasi: tgl,
            profesi_petugas: obs.profesi_petugas || null,
            jam_kontak_pendaftaran: obs.jam_t0 ? `${tgl} ${obs.jam_t0}` : null,
            jam_dilayani_dokter: obs.jam_t1 ? `${tgl} ${obs.jam_t1}` : null,
            jenis_pasien: obs.jenis_pasien || null,
            alasan_tidak_tercapai: obs.alasan_tidak_tercapai || null,
            uraian_tidak_tercapai: obs.uraian_tidak_tercapai || null,
            data_source: obs.data_source || "manual",
          };
        }),
      numerator_tercapai: this.numerator,
      denominator_total: this.denominator,
      capaian_persen: this.denominator > 0 ? parseFloat(this.capaianPct.toFixed(2)) : null,
      status_capaian: this.denominator > 0 ? this.statusCapaian : null,
      alasan_tidak_tercapai_utama: this.form.alasan_tidak_tercapai_utama || [],
      uraian_lengkap: trim(this.form.uraian_lengkap),
      rencana_tindak_lanjut_umum: trim(this.form.rencana_tindak_lanjut_umum),
      rtl: this.rtlRows
        .filter(r => r.masalah_gap || r.analisa_akar_masalah || r.rencana_tindak_lanjut)
        .map((r, i) => ({
          nomor_urut: i + 1,
          masalah_gap: r.masalah_gap || null,
          analisa_akar_masalah: r.analisa_akar_masalah || null,
          rencana_tindak_lanjut: r.rencana_tindak_lanjut || null,
        })),
    };
  }

  async importFromAntrean() {
    if (!this.session?.id) {
      this.showWarning("Simpan draft terlebih dahulu sebelum import dari antrean");
      return;
    }
    if (!this.form.poliklinik_kode) {
      this.showWarning("Pilih poliklinik terlebih dahulu");
      return;
    }
    this.importing = true;
    try {
      const resp = await OwtSvc.importAntrean(this.session.id, {
        tanggal: this.form.tanggal_sampling,
        poliklinik_kode: this.form.poliklinik_kode,
      });
      if (resp?.data?.status == "1") {
        const imported = resp.data.data || [];
        for (let i = 0; i < Math.min(imported.length, OBS_COUNT); i++) {
          const src = imported[i];
          this.observations[i].pasien_rm = src.pasien_rm || "";
          this.observations[i].pasien_nama = src.pasien_nama || "";
          this.observations[i].jam_t0 = src.jam_t0 || "";
          this.observations[i].jam_t1 = src.jam_t1 || "";
          this.observations[i].jenis_pasien = src.jenis_pasien || "";
          this.observations[i].profesi_petugas = src.profesi_petugas || "";
        }
        appModule.NoticeDelay(`Berhasil import ${imported.length} data dari antrean`);
      }
    } catch {
      // handled by ErrorAlert
    }
    this.importing = false;
  }

  async onRmBlur(idx: number) {
    const obs = this.observations[idx];
    if (!obs || !obs.pasien_rm || obs.pasien_rm.length < 3) return;
    // Skip if name already filled
    if (obs.pasien_nama && obs.pasien_nama.trim() !== "") return;

    this.$set(obs, "_rmLoading", true);
    try {
      const resp = await OwtSvc.lookupPatientByRm(obs.pasien_rm);
      if (resp?.data?.status == "1" && resp.data.data) {
        obs.pasien_nama = resp.data.data.pasien_nama || "";
      }
    } catch {
      // silent — patient not found
    }
    this.$set(obs, "_rmLoading", false);
  }

  async simpanDraft() {
    if (!this.validateBeforeSubmit(false)) return;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;
      if (this.session?.id) {
        resp = await OwtSvc.update(this.session.id, payload);
      } else {
        resp = await OwtSvc.create(payload);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Draft berhasil disimpan");
        this.session = resp.data.data;
        this.$emit("saved");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.saving = false;
  }

  async submitAndSign() {
    if (!this.validateBeforeSubmit(true)) return;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      if (!this.session?.id) {
        const resp = await OwtSvc.create(payload);
        if (resp?.data?.status == "1") {
          this.session = resp.data.data;
        } else {
          this.saving = false;
          return;
        }
      } else {
        await OwtSvc.update(this.session.id, payload);
      }
      this.showSignPetugasDialog = true;
    } catch {
      // handled by ErrorAlert
    }
    this.saving = false;
  }

  async doSubmitSign() {
    if (!this.signPassword) {
      this.showWarning("Password wajib diisi");
      return;
    }
    this.signing = true;
    try {
      const payload = { ...this.buildPayload(), password: this.signPassword };
      const resp = await OwtSvc.submit(this.session.id, payload);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Sesi berhasil disimpan & ditandatangani Petugas");
        this.showSignPetugasDialog = false;
        this.signPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.signing = false;
  }

  async doSignVerifikator() {
    if (!this.signPassword) {
      this.showWarning("Password wajib diisi");
      return;
    }
    this.signing = true;
    try {
      const resp = await OwtSvc.signVerifikator(this.session.id, { password: this.signPassword });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil TTD sebagai Verifikator / PIC Mutu");
        this.showSignVerifikatorDialog = false;
        this.signPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.signing = false;
  }

  async doSignKepalaUnit() {
    if (!this.signPassword) {
      this.showWarning("Password wajib diisi");
      return;
    }
    this.signing = true;
    try {
      const resp = await OwtSvc.signKepalaUnit(this.session.id, { password: this.signPassword });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil TTD sebagai Kepala Unit");
        this.showSignKepalaUnitDialog = false;
        this.signPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch {
      // handled by ErrorAlert
    }
    this.signing = false;
  }

  printPdf() {
    if (this.session?.id) OwtSvc.printPdf(this.session.id);
  }

  // ==================== LIFECYCLE ====================
  async mounted() {
    // Load poliklinik list
    if (!this.storeModule.poliklinikList.length) {
      await this.storeModule.loadPoliklinik();
    }

    // Auto-fill petugas from logged-in user
    this.autoFillPetugas();

    // Initialize observations
    this.initEmptyObservations();

    // If editing existing session (accept sessionData or eventData prop)
    const inputData = this.sessionData || this.eventData;
    if (inputData?.id) {
      await this.storeModule.loadDetail(inputData.id);
      this.session = this.storeModule.currentSession;
      this.populateFromSession();
    }
  }
}
